var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 72,
    viewBox: "0 0 58 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 0H21.5L0 21.5V64.5C0 68.4417 3.225 71.6667 7.16667 71.6667H50.1667C54.1083 71.6667 57.3333 68.4417 57.3333 64.5V7.16667C57.3333 3.225 54.1083 0 50.1667 0ZM50.1667 7.16667V64.5H7.16667V24.4742L24.4742 7.16667H50.1667Z",
    fill: "#BCBEDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39.4173L28.6667 53.7507L14.3333 39.4173L19.3858 34.3648L25.0833 40.0265V25.1557L32.25 25.084V40.0265L37.9475 34.329L43 39.4173Z",
    fill: "#BCBEDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCards);
export default __webpack_public_path__ + "static/media/downloadCards.6fcbf63765de3b3ae5e7862698e6507f.svg";
export { ForwardRef as ReactComponent };